import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Slide,
} from "@mui/material";
import { useState, forwardRef } from "react";
import axios from "axios";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Success = ({ open, close }) => {
  return (
    <Dialog
      open={open}
      onClose={close}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          borderRadius: "18px",
          backgroundColor: "#f2efeb",
        },
      }}
    >
      <DialogTitle style={{ fontFamily: "Montserrat", color: "#810605" }}>
        Success!
      </DialogTitle>
      <DialogContent>
        <Typography>We have received your response!</Typography>
        <Typography>We can't wait to see you!</Typography>
      </DialogContent>
      <DialogActions style={{ marginRight: 20, marginBottom: 10 }}>
        <Button
          onClick={close}
          style={{ fontFamily: "Montserrat", color: "#810605" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Success;
